// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2LDHA","alert":"SettungsInbox_alert__Vo7Yc"};